import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import validate from 'validate.js';
import _ from 'underscore';

// Material helpers
import { withStyles } from '@material-ui/core/styles/index';

// Material components
import Grid from '@material-ui/core/Grid/index';
import Button from '@material-ui/core/Button/index';
import CircularProgress from '@material-ui/core/CircularProgress/index';
import IconButton from '@material-ui/core/IconButton/index';
import TextField from '@material-ui/core/TextField/index';
import Typography from '@material-ui/core/Typography/index';
import Paper from "@material-ui/core/Paper";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import Divider from '@material-ui/core/Divider';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import base64 from 'react-native-base64'

// Shared components
import FacebookIcon from 'icons/Facebook';
import GoogleIcon from 'icons/Google';

// Component styles
import styles from './styles';

// Form validation schema
import schema from './schema';
import { api_host } from '../../common/globals/constants';
import {getPass} from '../../services/getMail'
import { ButtonGroup } from '@material-ui/core';

import 'isomorphic-fetch';
import 'es6-promise';

// Service methods
const signIn = (email, pass) => {
    return new Promise(resolve => {
        setTimeout(() => {

            fetch(api_host+'/api-auth-reporte/', {
                method: 'POST', // or 'PUT'
                body: JSON.stringify({email: email,
                                    password: pass}), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 1) {
                        resolve(false);
                    } else {
                        sessionStorage.setItem('key', response.data.token)
                        sessionStorage.setItem('user', response.data.cliente_usuario_id)
                        sessionStorage.setItem('user_name', response.data.nombre_usuario)
                        sessionStorage.setItem('client_id', response.data.cliente_id)
                        sessionStorage.setItem('email', response.data.email)
                        sessionStorage.setItem('profile', response.data.perfil.nombre)
                        sessionStorage.setItem('profile_id', response.data.perfil.reporte_perfil_id)
                        sessionStorage.setItem('client_name', response.data.cliente.nombre)
                        sessionStorage.setItem('tz', response.data.zona_horaria.valor)
                        sessionStorage.setItem('period_semaphore', response.data.preferencia_semaforo_periodo)
                        sessionStorage.setItem('max_horariohabil', response.data.cliente.max_horariohabil)
                        if (response.data.vista_compacta == null){
                            sessionStorage.setItem('extend_view', false)
                        } else { 
                            sessionStorage.setItem('extend_view', response.data.vista_compacta)
                        }
                        resolve(true);
                    }
                }
                );
        }, 100);
    });
};



class SignIn extends Component {
    constructor (props) {

        //Asignación de helper para prellenado de mail
        let token = window.location.search.split("=")[1] ? 
                    window.location.search.split("=")[0] === "?token" ? 
                        window.location.search.split("=")[1] : "" : "";
        let mail=""
        let password=""
        if(token!==""){
            token=atob(token).split(".atentus.")
            mail=token[0]
            password=atob(token[1])
        }
        
        super(props);   
        this.state = {
            values: {
                email: mail,
                password: password
            },
            touched: {
                email: false,
                password: false
            },
            errors: {
                email: null,
                password: null
            },
            isValid: false,
            isLoading: false,
            submitError: null,
            open: false,
            openModal:false,
            emailPass:"",
            colorCall:"",
            call:"",
            display:"none"
        };
    }
    componentDidMount(){
        const {values}=this.state
        if(values.email!=="" &&values.password!==""){
            this.handleSignIn()
        }
    }

    handleBack = () => {
        const { history } = this.props;

        history.goBack();
    };

    validateForm = _.debounce(() => {
        const { values } = this.state;

        const newState = { ...this.state };
        const errors = validate(values, schema);

        newState.errors = errors || {};
        newState.isValid = errors ? false : true;

        this.setState(newState);
    }, 300);

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };

        newState.submitError = null;
        newState.touched[field] = true;
        newState.values[field] = value;

        this.setState(newState, this.validateForm);
    };
    handleFieldChangeMail =(field, value)=>{
        //console.log(value)
        this.setState({emailPass:value});
    }

    handleSignIn = async () => {
        sessionStorage.clear()
        try {
            const { history } = this.props;
            const { values } = this.state;
            this.setState({ isLoading: true });
            await signIn(values.email, values.password);
            if(sessionStorage.length>1){
                localStorage.setItem('isAuthenticated', true);
                history.push('/quickview');
            }else{
                this.setState({
                    isLoading: false,
                    isValid:false,
                    touched:{
                        email:false,
                        password:false,
                    },
                    open: true
                });
            }
            
        } catch (error) {
            this.setState({
                isLoading: false,
                serviceError: error,
                isValid:false,
                open: true
            });
        }
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        this.setState({
            open: false 
        })
      };
    
    footer=()=>{
        const {classes}= this.props

        let width = window.innerWidth;
        var footer=<Grid
        style={{paddingTop:"10%"}}
        container
        direction="row"
        justify="space-evenly"
        alignItems="center"
        >
        <Grid item
        lg={2}
        xs={2}>
            <Grid style={{paddingLeft:"23px"}} container item direction="row" justify="flex-end" alignItems="center">
                <Grid item>
                    <img className={classes.flag} src="/images/argentina.png"/>
                </Grid>
                <Grid item>
                    <img className={classes.flag} src="/images/chile.png" />
                </Grid>
                <Grid item>
                    <img className={classes.flag} src="/images/colombia.png"/>
                </Grid>
                <Grid item>
                    <img className={classes.flag} src="/images/mexico.png"/>
                </Grid>
                <Grid item>
                    <img className={classes.flag} src="/images/peru.png"/>
                </Grid>
                <Grid item>
                    <img className={classes.flag} src="/images/uruguay.png"/>
                </Grid>
            </Grid>
        </Grid>
        <Grid item
        lg={8}
        xs={8}>
            <Typography className={classes.sugestion} variant="h5">Todos los derechos reservados - Atentus</Typography>
        </Grid>
        <Grid container direction="row" justify="flex-start" alignItems="center" item lg={2} xs={2}>
            <Grid item lg={5} xs={5}>
                <a href="https://itunes.apple.com/us/app/appmobile-atentus/id1326836795" target="_blank">
                    <img  className={classes.imgLeft} src="/images/icono_appstore.png"/>
                </a>
            </Grid>
            <Grid item lg={5} xs={5}>
                <a href="https://play.google.com/store/apps/details?id=com.atentus.appmobileatentus&amp;hl=es&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" target="_blank">
                    <img className={classes.img} src="https://play.google.com/intl/en_us/badges/images/generic/es-419_badge_web_generic.png"/>
                </a>
            </Grid>
        </Grid>
    </Grid>
        if (width < 769) {
            footer=<Grid
            style={{paddingTop:"14%"}}
            container
            direction="row"
            justify="space-evenly"
            alignItems="center"
            >
            <Grid item>
                <Typography className={classes.sugestion} variant="h5">Todos los derechos reservados - Atentus</Typography>
            </Grid>
        </Grid>
        }
        return(
             footer
        )
    }

    getSite=()=>{
        window.open('https://www.atentus.com', '_blank');
    }

    onOpenModal = () => {
        this.setState({
            openModal: true,
        });
    };

    onCloseModal = () => {
        this.setState({ openModal: false });
    };

    mailCheck=()=>{
        var mail = this.state.emailPass
        mail=base64.encode(mail);
        getPass(mail).then(value=>{
            if(value==true){
                this.setState({ colorCall: "#41B900", call:'Un link ha sido enviado a su correo', display:"inline"});
            }else{
                this.setState({ colorCall: "#C2272D", call:'Ingrese un correo válido', display:"inline" });
            }
        })
    }

    render() {

        const { classes } = this.props;
        const {
            values,
            touched,
            errors,
            isValid,
            submitError,
            isLoading,
            open,
            openModal,
            emailPass,
            display,
            call,
            colorCall
        } = this.state;
        const showEmailError = touched.email && errors.email;
        const showPasswordError = touched.password && errors.password;
        return (
                <Grid
                    className={classes.root}
                    container
                >
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                    >
                        <Grid>
                           <Tooltip title="www.atentus.com" placement="left-end">
                                <Button style={{height:"50px"}} onClick={this.getSite}>
                                    <HomeWorkOutlinedIcon style={{fill:"white", height:"43px", width:"100px"}}/>  
                                </Button>
                            </Tooltip>
                        </Grid>

                    </Grid>
                    <Grid
                        item
                        lg={12}
                        xs={12}
                        xl={12}
                    >
                        <div style={{textAlign:"center", paddingTop:"5%"}}>
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                >
                                <Grid>
                                <img
                                        alt="Atentus logo"
                                        className={classes.logoImage}
                                        src="/images/logos/logo-atentus-gris.svg"
                                    />
                                  {/*   <Typography
                                        className={classes.titleLeft}
                                        variant="h1"
                                    >
                                        Atentus
                                        <img alt="" className={classes.titleImg} src={`favicon.ico`}/>
                                    </Typography> */}
                                </Grid>
                            </Grid>
                            <Grid style={{paddingTop:"20px"}}>
                                <Typography
                                    className={classes.textWhite}
                                    variant="h3"
                                >
                                    Sistema de Reporteria
                                </Typography>
                            </Grid>
                            <Grid item xs={12} style={{paddingTop:"10px"}}>
                                <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                >
                                    <Grid>
                                        <div className={classes.divIcon}>
                                            <PersonOutlineOutlinedIcon  fontSize="large" className={classes.iconIn}/>
                                        </div>
                                    </Grid>
                                    <Grid>
                                        <TextField
                                            className={classes.textField}
                                            //label="Usuario"
                                            name="email"
                                            onChange={event =>
                                                this.handleFieldChange('email', event.target.value)
                                            }
                                            type="text"
                                            value={values.email}
                                            variant="outlined"
                                        
                                        />
                                        </Grid>
                                </Grid>
                                
                            </Grid>
                            <Grid item xs={12} style={{paddingTop:"5px"}}>
                                
                                <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                >
                                    <Grid>
                                        <div className={classes.divIcon}>
                                            <LockOutlinedIcon  fontSize="large" className={classes.iconIn}/>
                                        </div>
                                    </Grid>
                                    <Grid>
                                        <TextField
                                            className={classes.textField}
                                            //label="Contraseña"
                                            name="password"
                                            onChange={event =>
                                                this.handleFieldChange('password', event.target.value)
                                            }
                                            type="password"
                                            value={values.password}
                                            variant="outlined"
                                        />
                                        
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} style={{paddingTop:"5px"}}>
                                <Grid>
                                    {showEmailError && (
                                        <Typography
                                            className={classes.fieldError}
                                            variant="body2"
                                        >
                                            {'Correo Inválido'}
                                        </Typography>
                                    )}
                                    {showPasswordError && (
                                        <Typography
                                            className={classes.fieldError}
                                            variant="body2"
                                        >
                                            {'Se Requiere Password'}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} style={{paddingTop:"5px"}}>
                                <Button onClick={this.onOpenModal}>
                                    <Typography variant="caption" style={{color:"white"}}>¿Ha olvidado su contraseña?</Typography>
                                </Button>
                                <Modal
                                    
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    open={openModal}
                                    onClose={this.onCloseModal}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    disableAutoFocus={true}
                                    disableEnforceFocus={true}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >                                    
                                    <Fade in={openModal}>
                                        <Grid style={{width:"500px", height:"283px", backgroundColor:"white"}}>
                                            <Grid
                                                container
                                                direction="row"
                                                justify="center"
                                                alignItems="center"
                                            >  
                                                <Grid item xs={12} xl={12} style={{height:"45px", textAlign:"center"}}>
                                                <img
                                                style={{height:"39px"}}
                                                        alt="Atentus logo"
                                                        src="/images/logos/logo-atentus-azul.svg"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} xl={12} style={{paddingTop:"5px", textAlign:"center"}}>
                                                    <Typography variant="caption">
                                                        Ingrese su correo electrónico y le enviaremos un enlace para crear una nueva contraseña.
                                                    </Typography>

                                                </Grid>
                                                <Grid item xs={12} xl={12} style={{paddingTop:"35px", textAlign:"center"}}>
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justify="center"
                                                        alignItems="center"
                                                    >
                                                        <Grid>
                                                            <TextField
                                                                className={classes.textField}
                                                                label="Ingrese Correo"
                                                                name="email"
                                                                onChange={event =>
                                                                    this.handleFieldChangeMail('email', event.target.value)
                                                                }
                                                                type="text"
                                                                value={emailPass}
                                                                variant="outlined"
                                                            
                                                            />
                                                            {showEmailError && (
                                                            <Typography
                                                                className={classes.fieldError}
                                                                variant="body2"
                                                            >
                                                                {'Correo Inválido'}
                                                            </Typography>
                                                            )}
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                                <Grid item xs={12} xl={12} style={{paddingTop:"15px", textAlign:"center"}}>
                                                    <Button
                                                        style={{width:"257px", backgroundColor:"#FF7E00", color:"white"}}
                                                        
                                                        //disabled={!isValid}
                                                        onClick={this.mailCheck}
                                                        size="large"
                                                        variant="contained"
                                                    >
                                                        Continuar
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} xl={12} style={{paddingTop:"15px", textAlign:"center", display:display}}>
                                                    <Typography style={{color:colorCall}}>{call}</Typography>
                                                </Grid>
                                            </Grid>                  
                                        </Grid>
                                    </Fade>
                                </Modal>
                            </Grid>
                            <Grid style={{paddingTop:"10px", paddingBottom:"40px"}}>
                            {submitError && (
                                <Typography
                                    className={classes.submitError}
                                    variant="body2"
                                >
                                    {submitError}
                                </Typography>
                            )}
                            {isLoading ? (
                                <CircularProgress className={classes.progress} />
                            ) : (
                                    <Button
                                        className={classes.signInButton}
                                        color="primary"
                                        disabled={!isValid}
                                        onClick={this.handleSignIn}
                                        size="large"
                                        variant="contained"
                                    >
                                        Ingresar
                                    </Button>
                                )}
                            {isValid ? (
                                null
                            ) : (
                                <Snackbar
                                        anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                        }}
                                        open={open}
                                        autoHideDuration={6000}
                                        onClose={this.handleClose}
                                    >
                                        <SnackbarContent
                                            className={classes.snackContent}
                                            aria-describedby="client-snackbar"
                                            message={
                                                <span id="client-snackbar" className={classes.message}>
                                                    <ErrorIcon className={(classes.icon, classes.iconVariant)}/>
                                                    Datos no válidos
                                                </span>
                                            }
                                            action={[
                                                <IconButton key="close" aria-label="close" color="inherit" onClick={this.handleClose}>
                                                    <CloseIcon className={classes.icon}/>
                                                </IconButton>
                                            ]}
                                        />

                                </Snackbar>
                                
                                    
                            )}
                            </Grid>
                            <Grid
                                style={{paddingTop:"5px", paddingBottom:"40px"}}
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                >
                                    <Divider  className={classes.textField} />
                            </Grid>
                            <Grid>
                                <Typography
                                    variant="caption"
                                    className={classes.textWhite}
                                    >
                                        Ayuda y consultas a:   soporte@atentus.com
                                </Typography>
                            </Grid>
                            {this.footer()}
                        </div>
                    </Grid>                
                </Grid>
        );
    }
}

SignIn.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};


export default compose(
    withRouter,
    withStyles(styles)
)(SignIn);
